import EncounterList from './EncounterList';

export default EncounterList;
